import * as React from "react";
function SvgTriangleLeft(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M24 32L8 16 24 0z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTriangleLeft);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
